import { ReactNode, useEffect } from "react";
import { Alert } from "antd";
import { CircleX, CheckCircle, Info, AlertTriangle } from "lucide-react";

type AlertType = "success" | "info" | "warning" | "error";

const icons: Record<AlertType, JSX.Element> = {
  success: <CheckCircle className="h-5 w-5 mr-2 text-green-600" />,
  info: <Info className="h-5 w-5 mr-2 text-blue-600" />,
  warning: <AlertTriangle className="h-5 w-5 mr-2 text-yellow-600" />,
  error: <CircleX className="h-5 w-5 mr-2 text-red-600" />,
};

function AppAlert({
  message,
  type = "info",
  setMessage,
  duration = 5000,
  showIcon = true,
}: {
  message: string | null | ReactNode;
  type?: AlertType;
  setMessage: (v: string | null) => void;
  duration?: number; // auto-close after ms
  showIcon?: boolean;
}) {
  useEffect(() => {
    if (message && duration > 0) {
      const timer = setTimeout(() => {
        setMessage(null);
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [message, setMessage, duration]);

  if (!message) return null;

  return (
    <Alert
      message={message}
      type={type}
      showIcon={showIcon}
      closable
      icon={showIcon ? icons[type] : undefined}
      onClose={() => setMessage(null)}
    />
  );
}

export default AppAlert;
